import React from 'react';
import Modal from 'react-modal';
import { IoCloseCircleOutline } from 'react-icons/io5';

const ModalComponent = ({
  isOpen,
  onRequestClose,
  contentLabel,
  children,
  height = 350,
  transY = -65,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    contentLabel={contentLabel}
    style={{
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
      content: {
        position: 'static !important',
        width: '380px',
        borderRadius: '20px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        padding: '40px',
      },
    }}
  >
    <div className='modal-details'>
      <button className='modal-btn-close' onClick={onRequestClose}>
        <IoCloseCircleOutline size={30} />
      </button>
      <h3 class='form-title' style={{ fontSize: '23px' }}>
        {contentLabel}
      </h3>
      {children}
    </div>
  </Modal>
);

export default ModalComponent;
